export interface DtmfButton {
  digit: string;
  letters: string;
  isSpecial?: boolean;
}

export const DTMF_BUTTONS: DtmfButton[][] = [
  [
    { digit: '1', letters: '' },
    { digit: '2', letters: 'ABC' },
    { digit: '3', letters: 'DEF' },
  ],
  [
    { digit: '4', letters: 'GHI' },
    { digit: '5', letters: 'JKL' },
    { digit: '6', letters: 'MNO' },
  ],
  [
    { digit: '7', letters: 'PQRS' },
    { digit: '8', letters: 'TUV' },
    { digit: '9', letters: 'WXYZ' },
  ],
  [
    { digit: '*', letters: '', isSpecial: true },
    { digit: '0', letters: '+' },
    { digit: '#', letters: '', isSpecial: true },
  ],
];
